import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  const ref = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const backgroundY = useTransform(scrollYProgress, [0, 1], ['0%', '20%']);
  const textY = useTransform(scrollYProgress, [0, 1], ['0%', '-50px']);
  return <section ref={ref} className="relative h-screen min-h-[600px] w-full flex items-center justify-center overflow-hidden" data-id="element-112">
      {/* Background Image with Parallax */}
      <motion.div className="absolute inset-0 w-full h-[120%]" style={{
      y: backgroundY,
      willChange: 'transform'
    }} data-id="element-113">
        <img src="https://cdn.magicpatterns.com/uploads/kBB3ifY3y5HfGycymnTLXg/header.jpg" alt="edel & weiss Zahnarztpraxis Empfang" className="w-full h-full object-cover" data-id="element-114" />
        <div className="absolute inset-0 bg-schwarz/50" data-id="element-115" />
      </motion.div>

      {/* Floating Gold Orbs */}
      <div className="gold-glow-orb w-96 h-96 top-1/4 left-1/4 opacity-10" data-id="element-116" />
      <div className="gold-glow-orb w-[30rem] h-[30rem] bottom-1/4 right-1/4 opacity-10" style={{
      animationDelay: '-5s'
    }} data-id="element-117" />

      <motion.div className="relative z-10 text-center px-6 max-w-5xl mx-auto mt-16" style={{
      y: textY,
      willChange: 'transform'
    }} data-id="element-118">
        <motion.h1 initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-5xl md:text-7xl lg:text-[5.5rem] font-poppins text-weiss leading-tight mb-4 text-balance uppercase tracking-tight font-[400]" data-id="element-119">
          Ihr Lächeln.
          <br data-id="element-120" />
          Unsere Berufung.
        </motion.h1>

        <motion.div initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 0.8,
        delay: 0.8,
        ease: 'easeOut'
      }} className="h-[2px] w-24 bg-gold mx-auto mt-8 mb-8 origin-center" data-id="element-121" />

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1.0,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-weiss/80 font-lora tracking-widest uppercase" data-id="element-122">
          Zahnarztpraxis edel & weiss — Nürnberg
        </motion.p>
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.5
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center" data-id="element-123">
        <span className="text-xs text-weiss/60 uppercase tracking-widest mb-2 font-poppins font-bold" data-id="element-124">
          Scrollen
        </span>
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-125">
          <ChevronDownIcon className="w-5 h-5 text-gold" data-id="element-126" />
        </motion.div>
      </motion.div>
    </section>;
}